const NotificationDanger = ({ message }) => {
  return (
    <div
      className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-green-800"
      role="alert"
    >
      <div>{message}</div>
    </div>
  );
};
export default NotificationDanger;
